<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="confirmBankAccountDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              saveTrustFund();
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <div v-if="editedItem !== null && editedItem !== undefined">
      <material-card
        :title="$t('views.trustfund.edit_{0}', [editedItem.Name])"
        :color="$vuetify.theme.themes.light.secondary"
        icon="business"
      >
        <div style="margin:10px;">
          <v-switch
            v-if="!selectedPlan.Current.IsTesting"
            color="primary"
            v-model="edit"
            :label="$t('globals.edit')"
          ></v-switch>
          <v-form ref="form" v-model="valid">
            <v-container fluid>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="3" align-self="end">
                  <trans-field
                    v-if="edit"
                    v-model="editedItem"
                    :label="$t('globals.name')"
                    field="Name"
                  ></trans-field>
                  <template v-else>
                    {{ $t("globals.name") }}
                    <br />
                    <span class="minfo">
                      {{ trans2(editedItem, "Name") }}
                    </span>
                  </template>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <v-layout row>
                    <v-flex
                      align-self-center
                      text-start
                      style="font-size: 18px"
                    >
                      {{ $t("views.trustfund.contact_details") }}
                    </v-flex>
                  </v-layout>
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    v-model="editedItem.PhoneNumber"
                    :label="$t('globals.telephone')"
                    required
                    :rules="[rules.phone]"
                    v-mask="telephoneMask"
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("globals.telephone") }}
                    <br />
                    <span class="minfo">
                      {{ formatPhone(editedItem.PhoneNumber) }}
                    </span>
                  </template>
                  <!-- <no-autocomplete-textfield
                    :disabled="edit !== true"
                    v-model="editedItem.PhoneNumber"
                    :label="$t('globals.telephone')"
                    required
                    :rules="[$rules.phone]"
                  ></no-autocomplete-textfield> -->
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3" align-self="end">
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    v-model="editedItem.Fax"
                    :label="$t('globals.fax_number')"
                    required
                    :rules="[rules.phone]"
                    v-mask="telephoneMask"
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("globals.fax_number") }}
                    <br />
                    <span class="minfo">
                      {{ formatPhone(editedItem.Fax) }}
                    </span>
                  </template>
                  <!-- <no-autocomplete-textfield
                    :disabled="edit !== true"
                    v-model="editedItem.Fax"
                    :label="$t('globals.fax_number')"
                    required
                    :rules="[$rules.phone]"
                  ></no-autocomplete-textfield> -->
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3" align-self="end">
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    v-model="editedItem.Email"
                    :label="$t('headers.contacts.email')"
                    required
                    :rules="[$rules.email]"
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("headers.contacts.email") }}
                    <br />
                    <span class="minfo">
                      {{ editedItem.Email }}
                    </span>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-container fluid>
            <v-layout row>
              <v-flex align-self-center text-start style="font-size: 18px">
                {{ $t("globals.address") }}
              </v-flex>
            </v-layout>
            <!-- <address-form
              ref="address"
              :disabled="edit !== true"
              :item="editedItem"
              :provinces="options.Models.Province"
              :readOnly="!edit"
            ></address-form> -->
            <canada-post-address
              :address="editedItem.Address"
              @update-address="editedItem.Address = $event"
              :readOnly="!edit"
              @valid="validAddress = $event"
            />
          </v-container>
          <v-container fluid>
            <v-layout row>
              <v-flex align-self-center text-start style="font-size: 18px">
                {{ $t("components.plancreationwizard.bank_account") }}
              </v-flex>
            </v-layout>
            <v-form ref="bankAccountForm" v-model="validAccount">
              <v-row>
                <div class="col-12 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    :label="$t('headers.members_management.Institution Number')"
                    v-model="editedItem.BankAccount.InstitutionNumber"
                    :rules="[
                      $rules.canadianBankInstitutionNumber,
                      $rules.required,
                    ]"
                    class="required"
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("headers.members_management.Institution Number") }}
                    <br />
                    <span class="minfo">
                      {{ editedItem.BankAccount.InstitutionNumber }}
                    </span>
                  </template>
                </div>
                <div class="col-12 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    :label="$t('headers.members_management.Account Number')"
                    v-model="editedItem.BankAccount.AccountNumber"
                    :rules="[$rules.canadianBankAccountNumber, $rules.required]"
                    class="
                      required
                    "
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("headers.members_management.Account Number") }}
                    <br />
                    <span class="minfo">
                      {{ editedItem.BankAccount.AccountNumber }}
                    </span>
                  </template>
                </div>
                <div class="col-12 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    v-if="edit"
                    :disabled="edit !== true"
                    :label="$t('headers.members_management.Transit Number')"
                    v-model="editedItem.BankAccount.TransitNumber"
                    :rules="[$rules.canadianBankTransitNumber, $rules.required]"
                    class="
                      required
                    "
                  ></no-autocomplete-textfield>
                  <template v-else>
                    {{ $t("headers.members_management.Transit Number") }}
                    <br />
                    <span class="minfo">
                      {{ editedItem.BankAccount.TransitNumber }}
                    </span>
                  </template>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </div>
        <v-card-actions v-if="edit === true">
          <v-btn text @click="edit = false" :disabled="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!allValid()"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
      <contacts
        identifier="trustFundContacts"
        ref="contacts"
        entity="TrustFund"
        filter="TrustFundId ne null"
        :trustFundId="editedItem.Id"
      ></contacts>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </div>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Contacts from "../components/Contacts";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import TransField from "../components/TransField";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { translate2 } from "../trans2";
import CanadaPostAddress from "@/components/CanadaPostAddress";

export default {
  name: "plans-parameters-info",
  components: {
    Contacts,
    ErrorHandler,
    TransField,
    NoAutocompleteTextfield,
    CanadaPostAddress,
  },
  mixins: [locker, planSetter],
  directives: { mask },
  data() {
    return {
      postalCodeMask: "A#A #A#",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      telephoneMask: "(###) ### - ####",
      error: null,
      edit: false,
      valid: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      editedItem: null,
      //originalItem: null
      validAccount: false,
      loading: false,
      saving: false,
      confirmBankAccountDialog: false,
      validAddress: true
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    edit: {
      async handler(v) {
        if (v) {
          //this.editedItem = JSON.parse(JSON.stringify(this.originalItem));
          try {
            this.loading = true;
            let item = await this.lock(
              this.getTrustFund,
              {
                plan: this.selectedPlan.Id,
              },
              () => {
                this.edit = false;
              }
            );
            if (item.BankAccount === null || item.BankAccount === undefined) {
              item.BankAccount = {};
            }
            this.editedItem = item;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        } else {
          this.unlock();
          this.initialize();
        }
      },
    },
    "editedItem.Status": {
      handler(v) {
        if (v) {
          this.editedItem.StatusId = this.editedItem.Status.Id;
        } else {
          this.editedItem.StatusId = null;
        }
      },
    },
    selectedPlan: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.initialize();
        }
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.initialize();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getTrustFund",
      "updateTrustFund",
      "validateBankAccount",
    ]),
    formatPhone(v) {
      return masker(v, this.telephoneMask, true, tokens);
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    allValid() {
      return this.valid && this.isBankAccountValid() && this.validAddress;
    },
    isBankAccountValid() {
      if (
        this.editedItem.BankAccount === null ||
        this.editedItem.BankAccount === undefined
      ) {
        return true;
      }
      this.editedItem.BankAccount.TrustFundId = this.editedItem.Id;
      for (let key of Object.keys(this.editedItem.BankAccount)) {
        console.log(key);
        if (
          this.editedItem.BankAccount[key] === null ||
          this.editedItem.BankAccount[key] === ""
        ) {
          delete this.editedItem.BankAccount[key];
        }
      }
      console.log(
        this.editedItem.BankAccount,
        Object.keys(this.editedItem.BankAccount)
      );
      if (Object.keys(this.editedItem.BankAccount).length === 1) {
        this.$refs.bankAccountForm.resetValidation();
        return true;
      }
      return this.validAccount;
    },
    async initialize() {
      this.loading = true;
      try {
        let item = (await this.getTrustFund({
          plan: this.selectedPlan.Id,
        })).data;
        if (item.BankAccount === null || item.BankAccount === undefined) {
          item.BankAccount = {};
        }
        this.editedItem = item;
        this.loading = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (this.editedItem.BankAccount) {
        if (Object.keys(this.editedItem.BankAccount).length > 1) {
          this.saving = true;
          try {
            const valid = (await this.validateBankAccount({
              payload: {
                InstitutionNumber: this.editedItem.BankAccount
                  .InstitutionNumber,
                TransitNumber: this.editedItem.BankAccount.TransitNumber,
              },
            })).data;

            if (!valid) {
              this.confirmBankAccountDialog = true;
            } else {
              await this.saveTrustFund();
            }
          } catch (error) {
            this.error = error;
          } finally {
            this.saving = false;
          }
        } else {
          this.saveTrustFund();
        }
      } else {
        this.saveTrustFund();
      }
    },
    async saveTrustFund() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.editedItem));
        delete item["@odata.context"];

        if (item.Address) {
          if (item.Address.Province) {
            item.Address.ProvinceId = item.Address.Province.Id;
            delete item.Address.Province;
            item.Address.TrustFundId = item.Id;
            // item.Address.PostalCode = this.unmask(item.Address.PostalCode, this.postalCodeMask);
            if (item.Address.Country) {
              item.Address.CountryId = item.Address.Country.Id;
              delete item.Address.Country;
            }
          } else {
            delete item.Address;
          }
        }

        if (item.PhoneNumber !== null && item.PhoneNumber !== undefined) {
          item.PhoneNumber = this.unmask(item.PhoneNumber, this.telephoneMask);
        }
        if (item.Fax !== null && item.Fax !== undefined) {
          item.Fax = this.unmask(item.Fax, this.telephoneMask);
        }
        if (item.BankAccount !== null && item.BankAccount !== undefined) {
          for (let key of Object.keys(item.BankAccount)) {
            if (
              item.BankAccount[key] === null ||
              item.BankAccount[key] === ""
            ) {
              delete item.BankAccount[key];
            }
          }
          if (Object.keys(item.BankAccount).length < 4) {
            delete item.BankAccount;
          }
        }

        await this.updateTrustFund({
          planid: this.selectedPlan.Id,
          payload: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.edit = false;
        this.editAddress = false;
        this.unlock();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    trans2(item, field) {
      return translate2(item, field);
    },
  },
};
</script>

<style>
.full-width {
  width: 100%;
}
.padding-top-14 {
  padding-top: 14px !important;
}
.padding-top-17 {
  padding-top: 17px !important;
}
</style>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
